export const questionnaireSampleType = {
  FamilyEvaluation: 1,
  FamilyTherapy: 2,
  TransportationEducative: 3,
  TransportationEducativeCompanion: 4,
  TransportationTherapy: 5,
  TransportationTherapyCompanion: 6,
};
